<template>
    <div> 
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getPrechargeOrderListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getPrechargeOrderListHandler">搜索查询</el-button>
                <el-button type="primary" @click="AliPayVisible = true">充值</el-button>
                <el-button type="primary"   v-if="hasAuthority('update_balance')"   @click="open">导出</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <!-- <el-table-column type="index" label="序号"></el-table-column>       -->
            <el-table-column prop="orderNo" label="订单编号" width="260"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称" width="160"></el-table-column>
            <el-table-column prop="priceRmb" label="充值金额（元）" width="120"></el-table-column>
            <el-table-column prop="payTypeName" label="充值来源" width="120"></el-table-column>
            <el-table-column prop="createOptName" label="充值人" width="160"></el-table-column>
            <el-table-column prop="createTime" label="充值时间" width="180"></el-table-column>
            <el-table-column prop="investStateName" label="充值状态" width="120"></el-table-column>
            <el-table-column prop="payStateName" label="支付状态" width="120"></el-table-column>
                        <!-- <el-table-column label="充值凭证">
　   　     <template slot-scope="scope">
　　　     　<img :src=" 'http://image.szxxtx.com:8888/' +scope.row.imgUrl" width="100" height="100" class="head_pic"/>
　         　</template>
           </el-table-column> -->
<!--            
            <el-table-column label="充值凭证：">
                     <template slot-scope="scope">
                    <el-image class="img-defined" :src=" 'http://image.szxxtx.com:8888/' +scope.row.imgUrl" alt=""></el-image >
                　</template>
                </el-table-column> -->
            <el-table-column prop="remark" label="备注"></el-table-column>
             <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button  type="text" @click="showVerify(scope.row)">充值凭证</el-button>
                </template>    
            </el-table-column>
        </el-table>
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <!-- <el-dialog :append-to-body="true"  title="支付宝充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            <div class="AliPayIcon">
                <div>
                   <img src="@/assets/alipay.png"> 
                </div>
            </div>
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrder">充 值</div>
            
        </el-dialog>  -->
                <!-- <el-dialog :append-to-body="true"  title="预存款充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            
            <p>充值提醒：</p>
            <p>致尊敬的代理商，公司原有的支付宝支付方式取消，烦请预充余额汇入以下公账（可开票），并把汇款截图发给相关客服人员以便添加款项，谢谢配合。</p>       
            <br/>  
                <br/>  
            <p>充值账户：</p>
            <p>公司名称：深圳市兰华物联科技有限公司</p>
            <p>开户银行：中国银行股份有限公司前海湾支行</p>
            <p>银行账号：749768577273</p>
            <br/>
              <br/>
            <div class="topUpBtn" @click="AliPayVisible = false">确 定</div>
            
        </el-dialog> -->

           <!-- <el-dialog :append-to-body="true"  title="支付宝充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            <div class="AliPayIcon">
                <div>
                   <img src="@/assets/alipay.png"> 
                </div>
            </div>
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrder">充 值</div>
            
        </el-dialog>  -->


        <el-dialog :append-to-body="true"  title="微信充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrder">充 值</div>
            
        </el-dialog> 





        
            <el-dialog :append-to-body="true"  :title="title" :visible.sync="shareImgs" width="600px" @close="cancel" :close-on-click-modal="false">
                   <p>
                       备注：
                   </p>
                   <p>
                       1： 请使用微信扫码支付，支付完成后 请点击 确定 刷新余额；
                   </p>
                   
                  
            <div style="text-align: center; width: 500px; border: ">               
               <img  :src="getImgUrl() +  addOrEditPkgForm.shareImg" alt="" width="300px" height="300px" style="margin: 0 auto;">  
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancel">确 定</el-button>
            </div>            

        </el-dialog> 


         <el-dialog :append-to-body="true"  title="充值凭证" :visible.sync="verifiedVisible" width="600px" class="verifiedDialog" @close="cancel" :close-on-click-modal="false">
            <el-form label-width="120px" :model="verifiedInfo" ref="verifiedInfo">
                <el-form-item>
                    <el-image class="img-defined" :src="imgUrl" 
                    :preview-src-list="[imgUrl]" alt=""></el-image >
                </el-form-item>
               
            </el-form>
        
        </el-dialog>    
    </div>
</template>
<script>
import {getPrechargeOrderList, addPrechargeOrder, alipayParam,lspayParam} from '@/api/order.js'
import common from '@/utils/common.js'
import {mapGetters } from "vuex";

export default {
    
    data(){
        return {
            shareImgs:false,
            searchForm: {
                agentName: '',
                time: ''
            },
            
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
             addOrEditPkgForm: {
                shopImgss:'',
                shopHeadImgs:'',
                state:'',
                pkgName:'',
                shopImgs: '',
                shopState: '',
                name:'',
                nameUrl:'',
                supplierName:'',
                account:'',
                pwd:'',
                pwdkey:'11',
                shareImg:'',
                shopInfo:''
                         
            },

            priceRmb:'',
            imgUrl:'',
            verifiedSrcList:[],
            verifiedVisible:false,
            AliPayVisible: false,

            
        }
    },
     computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

        fromPageIccid: function(){
            return this.$store.state.menu.iccidToAccount;
        },
    },
     watch: {
        fromPageIccid: function () {
            let fromPage = this.$store.state.menu.fromPage;
            if(fromPage == 'balanceRechargeRecord'){
                this.searchForm.iccid = this.fromPageIccid;
                this.getUserBalanceListHandler();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setFromPageIccid', '');
            }
        }
    },
    methods: {
         showVerify(row){
            this.verifiedVisible = true;
            this.verifiedSrcList[0] = row.imgUrl;
             this.imgUrl = process.env.VUE_APP_IMG_URL + '/' + row.imgUrl;

        },  
        cancel(){
            this.verifiedVisible=false;
            this.shareImgs=false;
            this.getPrechargeOrderListHandler();
        },
        formatPrice(){
            this.priceRmb = this.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        getPrechargeOrderListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getPrechargeOrderList(data).then(res => {
                common.listCallback(this, res, 'tbpg'); 
            })
        },
        //导出
        open(){
            this.$confirm('确定要导出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
                // type: 'warning'
            }).then(() => {
                var data = JSON.parse(JSON.stringify(this.searchForm));
                if(data.time != ''){
                    data.startTimeString = data.time[0] + ' 00:00:00'; 
                    data.endTimeString = data.time[1] + ' 23:59:59';
                }else{
                    data.startTimeString = '';
                    data.endTimeString = '';
                }
                delete data.time; 
                this.exportExcel('/mould/download/investOrder/listPage', data);
            }).catch(() => {        
            });
        },
        // doAddOrder(){  支付宝
        //     let data = {
        //         priceRmb:this.priceRmb,
        //     }
        //     addPrechargeOrder(data).then(res => {
        //         if (res.data.code == 200) {
        //             let fm = new FormData();
        //             fm.append("id", res.data.data.id);
        //             alipayParam(fm).then(newres => {
        //                 if (newres.data.code == 200) {
        //                     let routerData = this.$router.resolve({path:'/AliPay',query:{ htmlData: newres.data.data}});
        //                     // if (!!window.ActiveXObject || "ActiveXObject" in window) {
        //                     //     window.open(routerData.href, '_blank');
        //                     // }else{
        //                         window.open(routerData.href, '_blank');
        //                     // }
        //                 }
        //             })
        //         }else{
        //             this.$message.error(res.data.message);
                    
        //         }

        //         this.priceRmb = '';
        //         this.AliPayVisible = false;
        //     })
        // },


        //  doAddOrder(){
        //     let data = {
        //         priceRmb:this.priceRmb,
        //     }
        //     addPrechargeOrder(data).then(res => {
        //         if (res.data.code == 200) {
        //             let fm = new FormData();
        //             fm.append("id", res.data.data.id);
        //             lspayParam(fm).then(newres => {
        //                 if (newres.data.code == 200) {
        //                      this.addOrEditPkgForm.shareImg=newres.data.data.img;
        //                    this.shareImgs=true;
        //                 }
        //             })
        //         }else{
        //             this.$message.error(res.data.message);
                    
        //         }

        //         this.priceRmb = '';
        //         this.AliPayVisible = false;
        //     })
        // },

        doAddOrder(){
            let data = {
                priceRmb:this.priceRmb,
            }
            addPrechargeOrder(data).then(res => {
                if (res.data.code == 200) {
                    this.addOrEditPkgForm.shareImg=res.data.data.img;
                    this.shareImgs=true;
                }else{
                    this.$message.error(res.data.message);
                    
                }

                this.priceRmb = '';
                this.AliPayVisible = false;
            })
        },

        cancelToPay(){
            this.priceRmb = '';
            this.AliPayVisible = false;
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPrechargeOrderListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPrechargeOrderListHandler();
        }  
    },
    created () {
        this.getPrechargeOrderListHandler();
    }  
}
</script>
<style lang="less" scoped>
    .AliPayIcon{
        div{
            width:200px;
            margin: 0 auto;
            margin-bottom: 30px;

            img{ width: 100%;}
        }
    }

    

    


    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            border-bottom:1px solid #000;
            text-align: center;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 5;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            font-size: 14px;
        }

        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}  

    }



    .topUpBtn{
        display: inline-block;
        width: 100%;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border-radius: 5px;
        color: #fff;
        background: #3a8ee6;
    }
    
</style>

